'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popupMenu = require('../popup-menu/popup-menu');

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _headerLocal = require('./header.local.css');

var _headerLocal2 = _interopRequireDefault(_headerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/no-static-element-interactions */


var HeaderPopup = function (_PureComponent) {
  _inherits(HeaderPopup, _PureComponent);

  function HeaderPopup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderPopup.__proto__ || Object.getPrototypeOf(HeaderPopup)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function () {
      _this.props.hide();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderPopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          open = _props.open,
          icon = _props.icon,
          text = _props.text,
          hide = _props.hide,
          children = _props.children,
          toggleClassName = _props.toggleClassName,
          iconColor = _props.iconColor,
          align = _props.align,
          theme = _props.theme,
          className = _props.className;
      return _react2.default.createElement('li', {
        key: 'menu-account',
        className: (0, _classnames2.default)(_headerLocal2.default.menuItem, className)
      }, _react2.default.createElement(_popupMenu2.default, {
        visible: isOpen,
        onClick: open,
        hide: hide,
        text: text,
        icon: icon,
        iconColor: iconColor,
        toggleClassName: toggleClassName,
        closeOnClick: true,
        align: align,
        theme: theme
      }, children));
    }
  }]);

  return HeaderPopup;
}(_react.PureComponent);

HeaderPopup.propTypes = {
  /**
   * Rendered in the PopupMenu
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * Icon for PopupMenu
   */
  icon: _propTypes2.default.string,

  /**
   * Text for PopupMenu
   */
  text: _propTypes2.default.string,

  /**
   * Method to call when hiding
   */
  hide: _propTypes2.default.func.isRequired,

  /**
   * Method to call when opening
   */
  open: _propTypes2.default.func.isRequired,

  /**
   * Open/closed state
   */
  isOpen: _propTypes2.default.bool.isRequired,

  /**
   * Additional class name for PopupMenu
   */
  toggleClassName: _propTypes2.default.string,

  /**
   * Color of icon
   */
  iconColor: _propTypes2.default.string,

  /**
   * 'left' | 'center' | 'right'
   */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),

  /**
   * Style the component around PopupMenu
   */
  className: _propTypes2.default.string,

  /**
   * 'light' | 'dark'
   */
  theme: _propTypes2.default.oneOf(['light', 'dark'])
};
HeaderPopup.defaultProps = {
  align: 'left',
  theme: 'dark',
  iconColor: 'light',
  text: null,
  icon: null,
  toggleClassName: null,
  className: ''
};
exports.default = (0, _reactOnclickoutside2.default)(HeaderPopup);